import classNames from "classnames";
import { Wrap } from "components";
import styles from "./Loader.module.css";

interface LoaderProps {
  overlay?: boolean;
  style?: React.CSSProperties;
}

const Loader: React.FC<LoaderProps> = ({ overlay = true, style }) => (
  <Wrap
    if={overlay}
    with={(children) => <div className={styles.container}>{children}</div>}
  >
    <div className={classNames(styles.loader)} style={style} />
  </Wrap>
);

export { Loader };
